module.exports = __webpack_public_path__ + "img/6.04ae0837.jpg";